<div class="row m-0">
  <div class="col-12  page-heading-wrapper">
    <gb-ui-page-heading [titleText]="this.selectedDepartment?.extra?.services_page_title"></gb-ui-page-heading>
  </div>
</div>
<div class="govuk-width-container">
  <div class="row">
    <div class="col-sm-12">
      <ui-stepper [steps]="steps"></ui-stepper>
    </div>
  </div>
  <div class="govuk-grid-row" id="main-content" tabindex="-1">
    <div class="govuk-grid-column-full">
      <div class="govuk-grid-column-full">

        <h1 style="margin: 0;">{{datastoreService?.pageContent?.services_page_subtitle}}

          @if (agentMode) {
          <button type="button" class="govuk-button govuk-button--inverse heading-button" data-module="govuk-button"
            (click)="datastoreService?.agentRestart()">
            Agent Restart
          </button>
          }

        </h1>

        <p [innerHTML]="datastoreService?.pageContent?.services_page_subtitle_body"></p>

        <hr />
      </div>

      <div class="govuk-grid-column-full" *ngIf="loadedConfig">
        <!-- Hardcoded initial questions -->
        <form [formGroup]="initQuestions" *ngIf="this.journey === 'default'">
          <div class="govuk-form-group">
            <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse" for="ceramony_type">
              Make a new appointment for:
            </label>

            <select aria-required="true" (change)="validateAppointmentTypeQuestion()"
              formControlName="type_of_appointment" class="govuk-select govuk-select--inverse" id="ceramony_type"
              name="ceramony_type">
              <option *ngFor="let option of config?.journey_config?.appointments['appointment_types_dropdown']"
                [value]="option.id">
                {{ option.name }}
              </option>
            </select>

            <!-- <select *ngIf="adminOnlyJourney" (change)="validateCeramonyTypeQuestion()"
                      formControlName="type_of_appointment" class="govuk-select govuk-select--inverse" id="ceramony_type" name="ceramony_type">
                      <option *ngFor="let option of config['ceramony_type_options_admin']" [value]="option.id">
                          {{option.name}}
                      </option>
                  </select> -->
          </div>

          <div class="govuk-inset-text" *ngIf="invalidInitForm === 'over_two_years'">
            {{ 'SERVICES.CERMONY_ADVISE' | translate }}
          </div>
        </form>

        <div *ngIf="showOther" [innerHTML]="
          this.selectedDepartment?.extra?.service_page_type_of_ceremony_other
        "></div>

        <form [formGroup]="companyQuestionsForm" *ngIf="!showOther">
          <div *ngFor="let question of companyQuestions">

            <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="question.visible && question.address_lookup">
              <div class="govuk-form-group">
                <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="postcode_{{question.reference}}">
                  {{ question.name }}
                </label>
                <input [attr.aria-required]="question.required ? 'true' : null"
                  (keydown.space)="$event.preventDefault()" (keydown.spacebar)="$event.preventDefault()"
                  class="govuk-input govuk-input--width-20 govuk-input--inverse" id="postcode_{{ question.reference }}"
                  name="postcode_{{ question.reference }}" placeholder="Enter postcode"
                  formControlName="postcode_{{ question.reference }}" type="text" />
              </div>

              <p *ngIf="question.badPostcode" class="govuk-error-message" role="alert">
                {{ 'COMMON.INVALID_POSTCODE' | translate }}
              </p>

              <button type="button" class="govuk-button govuk-button--inverse" data-module="govuk-button"
                (click)="getAddress(question)">
                {{ 'COMMON.FIND_ADDRESS' | translate }}
              </button>

              <div *ngIf="question.addresses || question.answer">
                <div class="govuk-form-group" *ngIf="question.addresses?.length > 0">
                  <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse"
                    for="addresses">
                    Select address below
                  </label>
                  <select [attr.aria-required]="question.required ? 'true' : null" (change)="
                    setAddress($event, question)
                  " formControlName="{{ question.reference }}" class="govuk-select govuk-select--inverse"
                    id="addresses" name="addresses">
                    <!-- Hidden placeholder shown only when no value is selected -->
                    <option value="" disabled selected hidden>
                      Select address
                    </option>

                    <ng-container *ngFor="let option of question['addresses']">
                      <option [value]="option.address.full_address">
                        {{ option.address['full_address'] }}
                      </option>
                    </ng-container>
                  </select>
                </div>
              </div>
            </div>

            <span *ngIf="question.visible && !question.address_lookup">
              <!-- select -->
              <div class="govuk-form-group" *ngIf="
                (question.visible && question.detail_type === 'select') ||
                (question.visible && question.detail_type === 'select-price')
              ">
                <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse"
                  for="{{ question.reference }}">
                  {{ question.name }}
                </label>
                <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                  [innerHTML]="question.helptext"></div>
                <select [attr.aria-required]="question.required ? 'true' : null" (change)="
                  validateQuestions($event, question); onQuestionChange()
                " formControlName="{{ question.reference }}" class="govuk-select govuk-select--inverse"
                  id="{{ question.reference }}" name="{{ question.reference }}">
                  <option *ngFor="let option of question.options" [value]="option.name">
                    {{ option.name }}
                  </option>
                </select>
              </div>

              <!-- <div [ngClass]="{'hidden-question': question.hidden}" class="govuk-form-group"
                          *ngIf="question.visible && question.detail_type == 'select' || question.visible && question.detail_type == 'select-price'">
                          <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                                  *</span> {{question.name | translateSplit}}</label>

                          <ng-select [searchable]="false" [clearable]="false" appearance="outline"
                              id="{{question.reference}}" formControlName="{{question.reference}}" bindLabel="name"
                              bindValue="name" [items]="question.options"
                              (change)="validateQuestions($event, question); onQuestionChange();">
                          </ng-select>

                          <span *ngIf="question.helptext" class="help-text mb-3 pb-3" tabindex="0"
                              [innerHTML]="question.helptext | translateSplit | noSanitise">
                          </span>
                          <div *ngIf="form[question.reference].errors && showServices" class="invalid-feedback">
                              <div *ngIf="form[question.reference].errors.required" role="alert">
                                  {{ 'COMMON.IS_REQUIRED' | translate: {value: question.name | translateSplit } }}</div>

                              <ng-container *ngIf="question.required && showServices && !companyQuestionsForm.valid">
                                  <p class="invalid-feedback">This question is required</p>
                              </ng-container>
                          </div>
                      </div> -->

              <!-- text field -->
              <div [ngClass]="{
                  'govuk-form-group--error':
                    form[question.reference]?.errors
                }" class="govuk-form-group" *ngIf="
                question.visible &&
                question.detail_type === 'text_field' &&
                !question.resource_lookup && !question.resource_lookup && !question.aws_lookup &&
                !question.lookupValidated
              ">

                <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="{{ question.reference }}">
                  {{ question.name }}
                </label>

                <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                  [innerHTML]="question.helptext"></div>
                <app-form-error-messages [submitted]="true" [formGroup]="companyQuestionsForm" [form]="form"
                  [question]="question"></app-form-error-messages>
                <input [attr.aria-required]="question.required ? 'true' : null" [ngClass]="{
                    'govuk-input--error':
                      form[question.reference]?.errors
                  }" class="govuk-input govuk-input--inverse" name="eventName" id="{{ question.reference }}"
                  type="text" formControlName="{{ question.reference }}" (input)="
                  validateQuestions($event, question); onQuestionChange()
                " />
              </div>

              <!-- text field -->
              <div class="govuk-form-group"
                *ngIf="question.visible && question.detail_type === 'text_field' && !question.resource_lookup && question.aws_lookup">

                <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="{{question.reference}}">
                  {{question.name}}
                </label>

                <!-- Input + Check reference button — hidden once the lookup is locked in -->
                <ng-container *ngIf="!question.lookupSuccess">
                  <!-- RWRSPI-1090: a form-submission lookup answers every failure —
                       not found, expired, already used — with this one message. -->
                  <div class="lookup-error" role="alert"
                    *ngIf="question.formSubmissionLookup && (question.lookupError || question.lookupUsed || question.duplicateError)">
                    <span class="govuk-visually-hidden">Error:</span>
                    <p>
                      This reference number is invalid, has expired or already been used. Check carefully you have
                      entered the correct reference.
                    </p>
                    <p>
                      If the problem continues please contact the register office at <a
                        href="mailto:registeroffice@westminster.gov.uk">registeroffice&#64;westminster.gov.uk</a> so we
                      can advise you further.
                    </p>
                  </div>

                  <input [attr.aria-required]="question.required ? 'true' : null" class="govuk-input govuk-input--inverse"
                    id="{{question.reference}}" name="{{question.reference}}" placeholder=""
                    formControlName="{{question.reference}}" type="text">

                  <ng-container *ngIf="question.lookupError && !question.formSubmissionLookup" id="event-name-error" class="govuk-error-message">
                    <span class="govuk-visually-hidden">Error:</span>
                    <br>
                    <p style="margin-bottom: 0px; color: #d4351c; font-size: 19px; font-weight: 700;">
                      Please check carefully that the information has been entered correctly - numbers and spellings. If
                      there is no match we have not received your certificate yet from the Home Office. Please don't worry
                      - it can take a few days to arrive. Please try booking again in a few days. If there is still no
                      match please contact us <a
                        href="mailto:registeroffice@westminster.gov.uk">registeroffice&#64;westminster.gov.uk</a>

                    </p>
                  </ng-container>

                  <ng-container *ngIf="question.duplicateError && !question.formSubmissionLookup" id="event-name-error" class="govuk-error-message">
                    <span class="govuk-visually-hidden">Error:</span>
                    <br>
                    <p style="margin-bottom: 0px; color: #d4351c; font-size: 19px; font-weight: 700;">
                      This Home Office reference number and / or name have already been used for another person in this
                      booking. Please enter a new name and / or Home Office reference number.
                    </p>
                  </ng-container>

                  <ng-container *ngIf="question.lookupUsed && !question.formSubmissionLookup" id="event-name-error" class="govuk-error-message">
                    <span class="govuk-visually-hidden">Error:</span>
                    <br>
                    <p style="margin-bottom: 0px; color: #d4351c; font-size: 19px; font-weight: 700;">This home office
                      reference and full name
                      has already been used.</p>
                  </ng-container>

                  <ng-container *ngIf="question.searching" class="govuk-hint">
                    Searching...
                  </ng-container>

                  <br /><br />

                  <button type="button" class="govuk-button lookup-button" data-module="govuk-button"
                    (click)="awsLookup(question);">
                    {{'COMMON.LOOKUP' | translate}}
                  </button>
                </ng-container>

                <!-- Locked-in success display: shows verified name + reference, with Clear button to edit -->
                <div *ngIf="question.lookupSuccess && question.lookupResponse" class="govuk-inset-text">
                  <p class="govuk-body"><strong>Your reference is valid. Please continue.</strong></p>
                  <p class="govuk-body" *ngIf="question.lookupResponse.name">Name: {{ question.lookupResponse.name }}</p>
                  <p class="govuk-body" *ngIf="question.lookupResponse.home_office">Reference: {{ question.lookupResponse.home_office }}</p>
                  <button class="govuk-button govuk-button--secondary" type="button"
                    (click)="clearAwsLookup(question)">
                    Clear
                  </button>
                </div>
              </div>

              <!-- RESOURCE LOOKUP text field -->
              <div class="govuk-form-group" *ngIf="
                question.visible &&
                question.detail_type === 'text_field' &&
                question.resource_lookup
              ">

                <label class="govuk-label govuk-fieldset__legend--m govuk-fieldset__legend--m--inverse"
                  for="{{ question.reference }}">
                  {{ question.name }}
                </label>

                <div class="govuk-input__wrapper">
                  <input [attr.aria-required]="question.required ? 'true' : null"
                    placeholder="Start typing to search..." name="eventName" formControlName="{{ question.reference }}"
                    id="{{ question.reference }}" class="govuk-input govuk-input--with-clear govuk-input--inverse"
                    type="text" (keyup)="onSearch($event, question)" [value]="searchText" autocomplete="off" />
                  <div *ngIf="searchText" type="button" class="govuk-input__suffix" aria-label="Clear search"
                    aria-hidden="true" (click)="clearSearch(question)">
                    <b>X</b>
                  </div>
                </div>
                <span *ngIf="question.searching" class="govuk-hint govuk-hint--inverse">
                  Searching...
                </span>
                <span *ngIf="question.noResults" class="govuk-hint govuk-hint--inverse">
                  No results found
                </span>
                <ul *ngIf="suggestions?.length && !question.selected_resource"
                  class="govuk-list govuk-list--search-results">
                  <li *ngFor="let suggestion of suggestions" (click)="selectSuggestion(suggestion, question)"
                    (keydown.enter)="selectSuggestion(suggestion, question)" tabindex="0" class="govuk-list__item">
                    <span class="govuk-list__item-icon">
                      <img src="./assets/images/search.svg" alt="Search icon" />
                    </span>
                    {{ suggestion.pretty_name || suggestion.venue_name }}
                  </li>
                </ul>
              </div>

              <!-- text area -->
              <div class="govuk-form-group"
                *ngIf="question.visible && question.detail_type === 'text_area' && question.conditionals.component_type !== 'file-upload'">

                <label class="govuk-label govuk-label--m govuk-label--m--inverse" for="{{ question.reference }}">
                  {{ question.name }}
                </label>

                <div id="{{ question.reference }}-hint" class="govuk-hint govuk-hint--inverse">
                  {{ question.helptext }}
                </div>
                <textarea [attr.aria-required]="question.required ? 'true' : null"
                  formControlName="{{ question.reference }}" class="govuk-textarea govuk-input govuk-input--inverse"
                  id="{{ question.reference }}" name="moreDetail" rows="5" (input)="
                  validateQuestions($event, question); onQuestionChange()
                "></textarea>
              </div>

              <!-- date input -->
              <div *ngIf="question.visible && question.detail_type === 'date'" class="govuk-form-group" [ngClass]="{
                  'govuk-form-group--error':
                    form[question.reference]?.errors || 
                    dayModel?.errors || 
                    monthModel?.errors || 
                    yearModel?.errors
                }">
                <fieldset class="govuk-fieldset" role="group" [attr.aria-describedby]="
                    (question.helptext ? question.id + ' ' : '') +
                    (dayModel?.errors ? question.id + '-day-error ' : '') +
                    (monthModel?.errors ? question.id + '-month-error ' : '') +
                    (yearModel?.errors ? question.id + '-year-error ' : '')
                    ">
                  <legend class="govuk-fieldset__legend govuk-fieldset__legend--m govuk-fieldset__legend--m-inverse">
                    {{ question.name }}
                  </legend>
                  <div id="{{ question.id }}" class="govuk-hint govuk-hint--inverse" *ngIf="question.helptext"
                    [innerHTML]="question.helptext"></div>
                  <app-form-error-messages [submitted]="true" [formGroup]="companyQuestionsForm" [form]="form"
                    [question]="question"></app-form-error-messages>

                  <!-- errors not tracked by companyquestions form -->
                  <p *ngIf="dayModel?.errors" id="{{question.id}}-day-error" class="govuk-error-message">
                    <span class="govuk-visually-hidden">Error:</span>
                    Day is invalid
                  </p>
                  <p *ngIf="monthModel?.errors" id="{{question.id}}-month-error" class="govuk-error-message">
                    <span class="govuk-visually-hidden">Error:</span>
                    Month is invalid
                  </p>
                  <p *ngIf="yearModel?.errors" id="{{question.id}}-year-error" class="govuk-error-message">
                    <span class="govuk-visually-hidden">Error:</span>
                    Year is invalid
                  </p>

                  <div class="govuk-date-input">
                    <div class="govuk-date-input__item">
                      <div class="govuk-form-group">
                        <label class="govuk-label govuk-date-input__label" for="{{ question.id }}_d">
                          Day
                        </label>
                        <input [attr.aria-required]="question.required ? 'true' : null" [ngClass]="{
                          'govuk-input--error':
                            form[question.reference].errors?.required === true
                        }" (input)="
                          validateQuestions($event, question);
                          onQuestionChange()
                        " class="govuk-input govuk-date-input__input govuk-input--width-2 govuk-input--inverse"
                          id="{{ question.id }}_d" name="{{ question.id }}_d" type="text" inputmode="numeric"
                          (keydown)="allowOnlyNumbers($event)" maxlength="2" pattern="^(?:0?[1-9]|[12][0-9]|3[01])$"
                          [(ngModel)]="question.dateSplit.d" [ngModelOptions]="{standalone: true}"
                          #dayModel="ngModel" />
                      </div>
                    </div>
                    <div class="govuk-date-input__item">
                      <div class="govuk-form-group">
                        <label class="govuk-label govuk-date-input__label" for="{{ question.id }}_m">
                          Month
                        </label>
                        <input [attr.aria-required]="question.required ? 'true' : null" [ngClass]="{
                          'govuk-input--error':
                            form[question.reference].errors?.required === true
                        }" (input)="
                          validateQuestions($event, question);
                          onQuestionChange()
                        " class="govuk-input govuk-date-input__input govuk-input--width-2 govuk-input--inverse"
                          id="{{ question.id }}_m" name="{{ question.id }}_m" type="text" inputmode="numeric"
                          (keydown)="allowOnlyNumbers($event)" maxlength="2" pattern="^(0?[1-9]|1[0-2])$"
                          [(ngModel)]="question.dateSplit.m" [ngModelOptions]="{standalone: true}"
                          #monthModel="ngModel" />
                      </div>
                    </div>
                    <div class="govuk-date-input__item">
                      <div class="govuk-form-group">
                        <label class="govuk-label govuk-date-input__label" for="{{ question.id }}_y">
                          Year
                        </label>
                        <input [attr.aria-required]="question.required ? 'true' : null" [ngClass]="{
                          'govuk-input--error':
                            form[question.reference].errors?.required === true
                        }" (input)="
                          validateQuestions($event, question);
                          onQuestionChange()
                        " class="govuk-input govuk-date-input__input govuk-input--width-4 govuk-input--inverse"
                          id="{{ question.id }}_y" name="{{ question.id }}_y" type="text" inputmode="numeric"
                          (keydown)="allowOnlyNumbers($event)" maxlength="4" minlength="4"
                          [(ngModel)]="question.dateSplit.y" [ngModelOptions]="{standalone: true}"
                          #yearModel="ngModel" />
                      </div>
                    </div>
                  </div>
                </fieldset>
              </div>

              <!-- date -->
              <!-- <div [ngClass]="{'hidden-question': question.hidden}" class="govuk-form-group   "
                          *ngIf="question.visible && question.detail_type == 'date'">
                          <label><span *ngIf="question.required" aria-hidden="true" class="form-field-required-marker">
                                  *</span> {{question.name | translateSplit}}</label>

                          <input type="date" class="form-control govuk-input" formControlName="{{question.reference}}"
                              attr.aria-label="{{question.name}} date input" onkeydown="return false"
                              [attr.min]="question.hide_dates_in_past ? question.hide_dates_in_past : null"
                              [attr.max]="question.hide_dates_in_future ? question.hide_dates_in_future : null"
                              (change)="validateQuestions($event, question); onQuestionChange();">

                          <div *ngIf="form[question.reference].errors && showServices" class="invalid-feedback">
                              <div *ngIf="form[question.reference]?.errors?.required" role="alert">{{question.name}}
                                  {{'ACCOUNT.MY_ACCOUNT.IS_REQUIRED' | translate}}
                              </div>

                              <ng-container *ngIf="question.required && showServices && !companyQuestionsForm.valid">
                                  <p class="invalid-feedback">This question is required</p>
                              </ng-container>
                          </div>
                      </div> -->

              <!-- GOVUK radio -->
              <div *ngIf="question.visible && question.detail_type === 'radio'" class="govuk-form-group">
                <fieldset [attr.aria-required]="question.required ? 'true' : null" class="govuk-fieldset"
                  [attr.aria-describedby]="question.helptext ? 'changedName-hint-' + question.reference : null">
                  <legend class="govuk-fieldset__legend govuk-fieldset__legend--m govuk-fieldset__legend--m-inverse">
                    {{ question.name }}
                  </legend>
                  <div id="changedName-hint-{{question.reference}}" class="govuk-hint govuk-hint--inverse"
                    *ngIf="question.helptext" [innerHTML]="question.helptext"></div>

                  <ng-container *ngIf="question.citizenship_fees_table_show">
                    <!-- <legend class="govuk-fieldset__legend govuk-fieldset__legend--m govuk-fieldset__legend--m-inverse">
                      Costs
                    </legend> -->
                    <table class="govuk-table mb-0">
                      <thead class="govuk-table__head">
                        <tr class="govuk-table__row">
                          <th scope="col" class="govuk-table__header">Ceremony Days</th>
                          <th scope="col" class="govuk-table__header">Individual</th>
                          <th scope="col" class="govuk-table__header">Family</th>
                        </tr>
                      </thead>
                      <tbody class="govuk-table__body">
                        <tr class="govuk-table__row">
                          <th scope="row" class="govuk-table__header">Monday to Friday (after 9am, before 5pm)</th>
                          <td class="govuk-table__cell">£150</td>
                          <td class="govuk-table__cell">£210</td>
                        </tr>
                        <tr class="govuk-table__row">
                          <th scope="row" class="govuk-table__header">Monday to Friday (after 5pm)</th>
                          <td class="govuk-table__cell">£175</td>
                          <td class="govuk-table__cell">£230</td>
                        </tr>
                        <tr class="govuk-table__row">
                          <th scope="row" class="govuk-table__header">Saturday</th>
                          <td class="govuk-table__cell">£175</td>
                          <td class="govuk-table__cell">£230</td>
                        </tr>
                        <tr class="govuk-table__row">
                          <th scope="row" class="govuk-table__header">Sunday</th>
                          <td class="govuk-table__cell">£200</td>
                          <td class="govuk-table__cell">£270</td>
                        </tr>
                      </tbody>
                    </table>

                    <!-- <table class="govuk-table mb-0">
  <thead class="govuk-table__head">
    <tr class="govuk-table__row">
      <th scope="col" class="govuk-table__header">Citizenships</th>
      <th scope="col" class="govuk-table__header">Fee</th>
    </tr>
  </thead>
  <tbody class="govuk-table__body">
    <tr class="govuk-table__row">
      <th scope="row" class="govuk-table__header">Private Citizenship (Weekday)</th>
      <td class="govuk-table__cell">£150</td>
    </tr>
    <tr class="govuk-table__row">
      <th scope="row" class="govuk-table__header">Private Citizenship (Saturday)</th>
      <td class="govuk-table__cell">£175</td>
    </tr>
    <tr class="govuk-table__row">
      <th scope="row" class="govuk-table__header">Private Citizenship (Sunday)</th>
      <td class="govuk-table__cell">£200</td>
    </tr>
    <tr class="govuk-table__row">
      <th scope="row" class="govuk-table__header">Family Private Citizenship (Weekday)</th>
      <td class="govuk-table__cell">£210</td>
    </tr>
    <tr class="govuk-table__row">
      <th scope="row" class="govuk-table__header">Family Private Citizenship (Saturday)</th>
      <td class="govuk-table__cell">£230</td>
    </tr>
    <tr class="govuk-table__row">
      <th scope="row" class="govuk-table__header">Family Private Citizenship (Sunday)</th>
      <td class="govuk-table__cell">£270</td>
    </tr>
  </tbody>
</table> -->
                    
                  </ng-container>

                  <div class="govuk-radios" data-module="govuk-radios">
                    <div class="govuk-radios__item" *ngFor="let option of question.options">
                      <input formControlName="{{ question.reference }}" (change)="
                        updateRadio(
                          companyQuestionsForm,
                          question.reference,
                          option.name
                        )
                      " class="govuk-radios__input"
                        id="{{ question.reference + '_' + option.name.split(' ').join('') }}"
                        [attr.name]="question.reference" type="radio" [value]="option.name" />
                      <label class="govuk-label govuk-radios__label govuk-radios__label--inverse"
                        for="{{ question.reference + '_' + option.name.split(' ').join('') }}">
                        {{ option.name }}
                      </label>
                    </div>
                  </div>
                </fieldset>

              </div>

              <!--CHECKBOX-->
              <div class="govuk-form-group" *ngIf="question.visible && question.detail_type === 'check'">
                <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                  [innerHTML]="question.helptext"></div>
                <div class="govuk-checkboxes" data-module="govuk-checkboxes">
                  <div class="govuk-checkboxes__item">
                    <input [attr.aria-required]="question.required ? 'true' : null" (change)="
                      validateQuestions($event, question); onQuestionChange()
                    " class="govuk-checkboxes__input" id="{{ question.id }}" name="{{ question.id }}" type="checkbox"
                      value="{{ question.id }}" formControlName="{{ question.id }}" />
                    <label class="govuk-label govuk-checkboxes__label govuk-checkboxes__label--inverse"
                      for="{{ question.id }}">
                      {{ question.name }}
                    </label>
                  </div>
                </div>
              </div>

              <!-- <div [ngClass]="{'hidden-question': question.hidden}" class="  "
                          *ngIf="question.visible && question.detail_type === 'check'" class="govuk-checkboxes   "
                          data-module="govuk-checkboxes">
                          <span *ngIf="question.helptext" class="help-text mb-3" tabindex="-1"
                              [innerHTML]="question.helptext">
                          </span>

                          <div class="govuk-checkboxes__item">
                              <input id="{{question.id}}"
                                  (change)="validateQuestions($event, question); onQuestionChange();"
                                  class="govuk-checkboxes__input" type="checkbox" formControlName="{{question.id}}">
                              <label for="{{question.id}}" class="govuk-label govuk-checkboxes__label">
                                  {{question.name}}
                              </label>
                          </div>

                          <ng-container *ngIf="question.required && showServices && !companyQuestionsForm.valid">
                              <p class="invalid-feedback">This question is required</p>
                          </ng-container>
                      </div> -->

              <!-- normal heading-->
              <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                question.visible &&
                question.detail_type === 'heading' &&
                !question.conditionals.component_type
              ">
                <p>
                  <b>{{ question.name }}</b>
                </p>
                <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                  [innerHTML]="question.helptext"></div>
              </div>

              <!-- file upload (WCC upload box) -->
              <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                question.visible &&
                question.conditionals.component_type === 'file-upload'">
                <div class="govuk-form-group">
                  <label
                    class="govuk-label govuk-fieldset__legend govuk-fieldset__legend--m govuk-fieldset__legend--m-inverse"
                    for="{{ question.id }}">
                    {{ question.name }}
                  </label>

                  <div class="govuk-hint govuk-hint--inverse" id="upload-hint-{{ question.id }}">
                    {{ question.uploadHint }}
                  </div>

                  <p class="wcc-upload__error" role="alert" id="upload-error-{{ question.id }}"
                    *ngIf="question.uploadError">
                    {{ question.uploadError }}
                  </p>

                  <!-- Kept outside the state blocks below so the question's own
                       label/aria-describedby keep pointing at a live element. -->
                  <input [attr.aria-required]="question.required ? 'true' : null"
                    [attr.aria-describedby]="question.uploadError
                      ? 'upload-hint-' + question.id + ' upload-error-' + question.id
                      : 'upload-hint-' + question.id" [accept]="question.uploadAccept"
                    (change)="onFileUpload($event, question); validateQuestions($event, question); onQuestionChange()"
                    class="wcc-upload__input" id="{{ question.id }}" [name]="question.id" type="file">

                  <!-- reading the file -->
                  <div class="wcc-upload wcc-upload--busy" *ngIf="question.uploadBusy">
                    <span class="wcc-upload__spinner" role="status"
                      [attr.aria-label]="'Uploading ' + question.uploadFilename"></span>
                  </div>

                  <!-- a file is attached -->
                  <div class="wcc-upload wcc-upload--filled" *ngIf="!question.uploadBusy && question.uploadFilename">
                    <span class="wcc-upload__filename">{{ question.uploadFilename }}</span>
                    <button type="button" class="wcc-upload__remove" (click)="removeUploadedFile(question)">
                      Remove<span class="govuk-visually-hidden"> {{ question.uploadFilename }}</span>
                    </button>
                  </div>

                  <!-- empty -->
                  <label class="wcc-upload wcc-upload--empty" for="{{ question.id }}"
                    *ngIf="!question.uploadBusy && !question.uploadFilename">
                    <svg class="wcc-upload__icon" width="24" height="24" viewBox="0 0 24 24" fill="none"
                      aria-hidden="true" focusable="false">
                      <path d="M12 16V4m0 0L7.5 8.5M12 4l4.5 4.5M4 16v2.5A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V16"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <span class="wcc-upload__prompt">{{ question.uploadPrompt }}</span>
                  </label>
                </div>
              </div>


              <!-- inset heading -->
              <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                question.visible &&
                question.detail_type === 'heading' &&
                question.conditionals.component_type === 'inset_text'
              ">
                <div class="govuk-inset-text" [innerHTML]="addHyperlinks(question.name)">
                </div>
                <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                  [innerHTML]="addHyperlinks(question.helptext)"></div>
              </div>

              <!-- body component -->
              <div [ngClass]="{ 'hidden-question': question.hidden }"
                *ngIf="question.visible && question.detail_type === 'heading' && question.conditionals.component_type === 'body'">
                <div id="{{ question.id }}" [innerHTML]="addHyperlinks(question.conditionals.component_text)"></div>

                <ng-container *ngIf="question.citizenship_fees_table_show">
                  <!-- <legend class="govuk-fieldset__legend govuk-fieldset__legend--m govuk-fieldset__legend--m-inverse">
                    Costs
                  </legend> -->
                  <table class="govuk-table mb-0">
                    <thead class="govuk-table__head">
                      <tr class="govuk-table__row">
                        <th scope="col" class="govuk-table__header">Ceremony Days</th>
                        <th scope="col" class="govuk-table__header">Individual</th>
                        <th scope="col" class="govuk-table__header">Family</th>
                      </tr>
                    </thead>
                    <tbody class="govuk-table__body">
                      <tr class="govuk-table__row">
                        <th scope="row" class="govuk-table__header">Monday to Friday (after 9am, before 5pm)</th>
                        <td class="govuk-table__cell">£150</td>
                        <td class="govuk-table__cell">£210</td>
                      </tr>
                      <tr class="govuk-table__row">
                        <th scope="row" class="govuk-table__header">Monday to Friday (after 5pm)</th>
                        <td class="govuk-table__cell">£175</td>
                        <td class="govuk-table__cell">£230</td>
                      </tr>
                      <tr class="govuk-table__row">
                        <th scope="row" class="govuk-table__header">Saturday</th>
                        <td class="govuk-table__cell">£175</td>
                        <td class="govuk-table__cell">£230</td>
                      </tr>
                      <tr class="govuk-table__row">
                        <th scope="row" class="govuk-table__header">Sunday</th>
                        <td class="govuk-table__cell">£200</td>
                        <td class="govuk-table__cell">£270</td>
                      </tr>
                    </tbody>
                  </table>

                  <!-- <table class="govuk-table mb-0">
                    <thead class="govuk-table__head">
                      <tr class="govuk-table__row">
                        <th scope="col" class="govuk-table__header">Citizenships</th>
                        <th scope="col" class="govuk-table__header">Fee</th>
                      </tr>
                    </thead>
                    <tbody class="govuk-table__body">
                      <tr class="govuk-table__row">
                        <th scope="row" class="govuk-table__header">Private Citizenship (Weekday)</th>
                        <td class="govuk-table__cell">£150</td>
                      </tr>
                      <tr class="govuk-table__row">
                        <th scope="row" class="govuk-table__header">Private Citizenship (Saturday)</th>
                        <td class="govuk-table__cell">£175</td>
                      </tr>
                      <tr class="govuk-table__row">
                        <th scope="row" class="govuk-table__header">Private Citizenship (Sunday)</th>
                        <td class="govuk-table__cell">£200</td>
                      </tr>
                      <tr class="govuk-table__row">
                        <th scope="row" class="govuk-table__header">Family Private Citizenship (Weekday)</th>
                        <td class="govuk-table__cell">£210</td>
                      </tr>
                      <tr class="govuk-table__row">
                        <th scope="row" class="govuk-table__header">Family Private Citizenship (Saturday)</th>
                        <td class="govuk-table__cell">£230</td>
                      </tr>
                      <tr class="govuk-table__row">
                        <th scope="row" class="govuk-table__header">Family Private Citizenship (Sunday)</th>
                        <td class="govuk-table__cell">£270</td>
                      </tr>
                    </tbody>
                  </table> -->
                  
                </ng-container>
              </div>

              <!-- govbook info box -->
              <wcc-info-box [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                  question.visible &&
                  question.detail_type === 'heading' &&
                  question.conditionals.component_type === 'wcc-information_box'
                " [content]="question.conditionals.component_text">
              </wcc-info-box>

              <wcc-warning-box [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
              question.visible &&
              question.detail_type === 'heading' &&
              question.conditionals.component_type === 'wcc-warning_box'
            " [question]="{
              component_text: question.conditionals.component_text
            }" [returnConfig]="returnConfig">
              </wcc-warning-box>

              <!-- details component type -->
              <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                question.visible &&
                question.detail_type === 'heading' &&
                question.conditionals.component_type === 'details'
              ">
                <details class="govuk-details">
                  <summary class="govuk-details__summary">
                    <span class="govuk-details__summary-text">
                      {{ question.name }}
                    </span>
                  </summary>
                  <!-- <div class="govuk-details__text" [innerHTML]="addHyperlinks(question)">hello?</div> -->
                  <div class="govuk-details__text" [innerHTML]="question.conditionals.component_text"></div>

                </details>
                <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                  [innerHTML]="addHyperlinks(question.helptext)"></div>
              </div>

              <!-- notifcation banner heading -->
              <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                question.visible &&
                question.detail_type === 'heading' &&
                question.conditionals.component_type === 'notification_banner'
              ">
                <div class="govuk-notification-banner" role="region" aria-labelledby="govuk-notification-banner-title"
                  data-module="govuk-notification-banner">
                  <div class="govuk-notification-banner__header">
                    <h2 class="govuk-notification-banner__title" id="govuk-notification-banner-title">
                      {{ question.name }}
                    </h2>
                  </div>
                  <div class="govuk-notification-banner__content">
                    <p class="govuk-notification-banner__heading govuk-notification-banner__heading--inverse"
                      [innerHTML]="addHyperlinks(question)"></p>
                  </div>
                </div>
                <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                  [innerHTML]="question.helptext"></div>
              </div>

              <!-- warning heading -->
              <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                question.visible &&
                question.detail_type === 'heading' &&
                question.conditionals.component_type === 'warning_text'
              ">
                <div class="govuk-warning-text">
                  <span class="govuk-warning-text__icon" aria-hidden="true">!</span>
                  <strong class="govuk-warning-text__text">
                    <span class="govuk-visually-hidden">Important</span>
                    {{ question.name }}
                  </strong>
                </div>
                <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                  [innerHTML]="question.helptext"></div>
              </div>

              <!-- panel heading -->
              <div [ngClass]="{ 'hidden-question': question.hidden }" *ngIf="
                question.visible &&
                question.detail_type === 'heading' &&
                question.conditionals.component_type === 'panel'
              ">
                <div class="govuk-panel govuk-panel--confirmation">
                  <h1 class="govuk-panel__title">
                    {{ question.name }}
                  </h1>
                  <div class="govuk-panel__body" [innerHTML]="addHyperlinks(question)"></div>
                </div>
                <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                  [innerHTML]="question.helptext"></div>
              </div>

              <!-- heading 2 -->
              <div [ngClass]="{ 'hidden-question': question.hidden }"
                *ngIf="question.visible && question.detail_type === 'heading_2'">
                <h2 class="govuk-heading-l govuk-heading-l--inverse">
                  {{ question.name }}
                </h2>
                <div *ngIf="question.helptext" id="{{ question.id }}" class="govuk-hint govuk-hint--inverse"
                  [innerHTML]="question.helptext"></div>
              </div>
            </span>
          </div>
        </form>

        <div *ngIf="showServices && companyQuestionsForm.valid">
          <div class="govuk-button-group">
            <button type="submit" class="govuk-button govuk-button--inverse" data-module="govuk-button"
              (click)="selectService()">
              {{ 'COMMON.NEXT' | translate }}
            </button>
          </div>
        </div>

        <!-- <ng-container *ngIf="showServices && !companyQuestionsForm.valid">
          <div role="alert" class="guidance-message cannot-proceed ng-star-inserted">
            <p><strong>Please complete the form above to proceed</strong>.</p>
          </div>
        </ng-container> -->

        <div *ngIf="!ageType.includes('16') && ageType.includes('10')">
          <div class="alert alert-danger mb-3" role="alert">
            <!-- {{ 'COMMON.HAS_COVID_SYMPTOMS' | translate }} -->
            <div class="pageTitle" *ngIf="translateService.currentLang === 'en'">
              {{ this.selectedDepartment?.extra?.under_10_guidance_text }}
            </div>
            <div class="pageTitle" *ngIf="translateService.currentLang === 'cy'">
              {{ this.selectedDepartment?.extra?.under_10_guidance_text_welsh }}
            </div>
          </div>
        </div>

        <!-- -->
        <ng-container *ngIf="!showServices && citizenshipExpired">
          <wcc-warning-box [question]="{
              component_text: 'Your Home Office reference has passed the required by date. Please contact the registrar office.'
            }" [returnConfig]="{}">
          </wcc-warning-box>
        </ng-container>
      </div>
    </div>
  </div>
